import { createService } from '@/services/service'

const apiUrl = '/api/v1'
const resource = 'patient/initial'

const { fetchAll } = createService({ resource, apiUrl })

export default {
  fetchAll,
}
